<template>
  <div>
    <div class="users-age-chart-container" style="background: none">
      <v-chart
        v-if="checkData()"
        :options="option"
        :autoresize="true"
        id="line-chart"
      ></v-chart>
      <p class="empty-data-container" v-else>
        No data found for this period
      </p>
    </div>
  </div>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/line";

import { mapGetters } from "vuex";

export default {
  name: "sdcs",
  data() {
    return {
      option: {}
    };
  },
  components: {
    "v-chart": ECharts
  },
  methods: {
    checkData() {
      return this.getAgeOfUsersChartDataset.some(x => x !== "0");
    },
    drawGraph() {
      this.option = {
        calculable: true,
        // radius:[ '50%', "10%"],
        // backgroundColor: "green",
        // barWidth: 40,
        silent: true,
        animationDuration: 1500,
        backgroundColor: "#383838",
        grid: {
          show: false,
          left: "0%",
          right: "0%",
          top: "40%",
          bottom: "3%",
          width: "100%",
          height: "75%",
          containLabel: true
        },
        xAxis: {
          //show: false,
          type: "value",
          //  data: [ "11 Aug" ],

          boundaryGap: false,
          min: 0,
          max: 100,
          splitNumber: 1,
          axisLabel: {
            inside: false
          }
        },
        yAxis: {
          type: "category",
          // data:["ee"],
          label: { show: false },
          position: "right",

          min: 0.5,
          max: 1,
          // splitNumber: 7,
          splitLine: { show: false }
        },

        series: [
          {
            name: "12", //a
            type: "bar",
            stack: "xx",
            label: {
              show: this.getAgeOfUsersChartDataset[0] != 0 ? true : false,
              position: "inside",
              formatter: "{c}% ",
              distance: 30,
              color: "#fff"
            },
            itemStyle: {
              color: new ECharts.graphic.LinearGradient(0, 0, 1, 1, [
                { offset: 0, color: "#FA9000" },
                { offset: 1, color: "#FA9039" }
              ]),
              borderColor: "#383838",
              borderWidth: 1
              // shadowColor:"#fff",
              // shadowOffsetX: 5
            },

            data: [this.getAgeOfUsersChartDataset[0]]
          },
          {
            name: "12", //a
            type: "bar",
            stack: "ss",
            label: {
              show: this.getAgeOfUsersChartDataset[0] != 0 ? true : false,
              position: "top",
              formatter: ".\n.\n\n0-12 ",
              color: "#fff",
              offset: [0, 40]
            },
            itemStyle: { color: "#383838" },
            data: [this.getAgeOfUsersChartDataset[0]]
          },
          {
            name: "18", //a
            type: "bar",
            stack: "xx",
            label: {
              show: this.getAgeOfUsersChartDataset[1] != 0 ? true : false,
              position: "inside",
              formatter: "{c}% ",
              distance: 30,
              color: "#fff"
            },
            itemStyle: {
              color: new ECharts.graphic.LinearGradient(0, 0, 1, 1, [
                { offset: 0, color: "#FA9039" },
                { offset: 1, color: "#FA803D" }
              ]),
              borderColor: "#383838",
              borderWidth: 1
              // shadowColor:"#fff",
              // shadowOffsetX: 5
            },

            data: [this.getAgeOfUsersChartDataset[1]]
          },
          {
            name: "18", //a
            type: "bar",
            stack: "ss",
            label: {
              show: this.getAgeOfUsersChartDataset[1] != 0 ? true : false,
              position: "top",
              formatter: "12-18\n.\n.",
              color: "#fff",
              offset: [0, -50]
            },
            itemStyle: { color: "#383838" },
            data: [this.getAgeOfUsersChartDataset[1]]
          },
          //////////////////////////
          {
            name: "25",
            type: "bar",
            stack: "xx",
            label: {
              show: this.getAgeOfUsersChartDataset[2] != 0 ? true : false,
              formatter: "{c}% ",
              color: "#fff",
              alignTo: "none",
              bleedMargin: 5
            },
            itemStyle: {
              color: new ECharts.graphic.LinearGradient(0, 0, 1, 1, [
                { offset: 0, color: "#FA803D" },
                { offset: 1, color: "#FA6345" }
              ]),
              borderColor: "#383838",
              borderWidth: 1
              // shadowColor:"#fff",
              // shadowOffsetX: 2
            },
            data: [this.getAgeOfUsersChartDataset[2]]
          },
          {
            name: "25", //a
            type: "bar",
            stack: "ss",
            label: {
              show: this.getAgeOfUsersChartDataset[2] != 0 ? true : false,
              position: "top",
              formatter: ".\n.\n\n18-25 ",
              color: "#fff",
              offset: [0, 40]
            },
            itemStyle: { color: "#383838" },
            data: [this.getAgeOfUsersChartDataset[2]]
          },
          ///////////////////////////////////
          {
            name: "30",
            type: "bar",
            stack: "xx",
            label: {
              show: this.getAgeOfUsersChartDataset[3] != 0 ? true : false,
              formatter: "{c}% ",
              color: "#fff",
              alignTo: "none",
              bleedMargin: 5
            },
            itemStyle: {
              color: new ECharts.graphic.LinearGradient(0, 0, 1, 1, [
                {
                  offset: 0,
                  color: "#FA5F45" //#FA6046
                },
                { offset: 1, color: "#FA434D" }
              ]),
              borderColor: "#383838",
              borderWidth: 1
            },

            data: [this.getAgeOfUsersChartDataset[3]]
          },
          {
            name: "30", //a
            type: "bar",
            stack: "ss",

            symbol: "arrow",
            symbolOffset: [0, -6],
            symbolSize: 20,
            showSymbol: true,
            symbolRotate: 4,
            symbolColor: "white",
            label: {
              show: this.getAgeOfUsersChartDataset[3] != 0 ? true : false,
              position: "top",
              formatter: "25-30 \n.\n.",
              // distance: 30,
              color: "#fff",
              offset: [0, -50]
            },
            itemStyle: { color: "#383838" },
            data: [this.getAgeOfUsersChartDataset[3]]
          },
          ///////////////////////////////////////////////////
          {
            name: "40",
            type: "bar",
            stack: "xx",
            label: {
              show: this.getAgeOfUsersChartDataset[4] != 0 ? true : false,
              formatter: "{c}% ",
              color: "#fff",
              alignTo: "none",
              bleedMargin: 5
            },
            itemStyle: {
              color: new ECharts.graphic.LinearGradient(0, 0, 1, 1, [
                { offset: 0, color: "#FA414E" },
                { offset: 1, color: "#FA3850" }
              ]),
              borderColor: "#383838",
              borderWidth: 1
            },

            data: [this.getAgeOfUsersChartDataset[4]]
          },
          {
            name: "40", //a
            type: "bar",
            stack: "ss",

            symbol: "arrow",
            symbolOffset: [0, -6],
            symbolSize: 20,
            showSymbol: true,
            symbolRotate: 4,
            symbolColor: "white",
            label: {
              show: this.getAgeOfUsersChartDataset[4] != 0 ? true : false,
              position: "top",
              formatter: ".\n.\n\n30-40",
              // distance: 30,
              color: "#fff",
              offset: [0, 40]
            },
            itemStyle: { color: "#383838" },
            data: [this.getAgeOfUsersChartDataset[4]]
          },
          ///////////////////////////////////////////////////
          {
            name: "50",
            type: "bar",
            stack: "xx",
            label: {
              show: this.getAgeOfUsersChartDataset[5] != 0 ? true : false,
              formatter: "{c}% ",
              color: "#fff",
              alignTo: "none",
              bleedMargin: 5
            },

            itemStyle: {
              color: new ECharts.graphic.LinearGradient(0, 0, 1, 1, [
                { offset: 0, color: "#FA3751" },
                { offset: 1, color: "#FA3552" }
              ]),
              borderColor: "#383838",
              borderWidth: 1
            },
            data: [this.getAgeOfUsersChartDataset[5]]
          },
          {
            name: "50",
            type: "bar",
            stack: "ss",
            label: {
              show: this.getAgeOfUsersChartDataset[5] != 0 ? true : false,
              position: "top",
              formatter: "40-50\n.\n.",
              color: "#fff",
              offset: [0, -50]
            },
            itemStyle: {
              color: "#383838"
            },
            data: [this.getAgeOfUsersChartDataset[5]]
          },
          //////////////////////////////////////////////////////////////////////
          {
            name: "50+",
            type: "bar",
            stack: "xx",
            label: {
              show: this.getAgeOfUsersChartDataset[6] != 0 ? true : false,
              formatter: "{c}% ",
              color: "#fff",
              alignTo: "none",
              bleedMargin: 5
              // fontSize: 14
            },
            itemStyle: {
              color: new ECharts.graphic.LinearGradient(0, 0, 1, 1, [
                { offset: 0, color: "#FA3452" },
                { offset: 1, color: "#FA3252" }
              ])
            },

            data: [this.getAgeOfUsersChartDataset[6]]
          },
          {
            name: "50+",
            type: "bar",
            stack: "ss",
            label: {
              show: this.getAgeOfUsersChartDataset[6] != 0 ? true : false,
              position: "top",
              formatter: ".\n.\n\n50+",
              color: "#fff",
              offset: [0, 40]
            },
            itemStyle: { color: "#383838" },

            data: [this.getAgeOfUsersChartDataset[6]]
          }
        ]
      };
    }
  },
  computed: {
    ...mapGetters(["getAgeOfUsersChartDataset"])
  },

  watch: {
    getAgeOfUsersChartDataset() {
      this.drawGraph();
    }
  }
};
</script>

<style>
.empty-data-container {
  font-size: 26px;
}
.users-age-chart-container {
  border: red;
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
}
#charAgeBar {
  /* height: 150px; */
  /* margin: 20px 0 0 0; */
  color: green;
}
</style>
